export const theme = {
    colors: {
      white: "#FFFFFF",
      alabaster: '#F7F7F7',
      whiteLilac: "#F4F1F9",
      shadyLady: "#292828",
      bonjour: "#EBEBEA",
      greyNickel: "#808080",
      //seance: "#d91b2c",
      seance: "#832697",
      codGrey: "#333333",
      pink: "#f40a99",
      darkPink: "#c3007d",
      intensivePink: '#f40a99',
      green: '#228B22',
    },
    breakPoints: {
      tabletMax: "1000px",
      mobileMax: "767px",
    }
  };
  